module.exports = __webpack_public_path__ + "static/media/30_B.25cf9cae.png";